(function () {
    'use strict';
    var app = angular.module('app');
    var apiUrl = "https://localhost:8417";

    app.factory('tmxStoreClientService', ['$q', '$resource', tmxStoreClientService]);

    function tmxStoreClientService($q, $resource) {

        var Client = $resource(apiUrl + '/api/clients?email=:email');

        var clientService = {
            getClientByEmail: getClientByEmail,
            saveClient: saveClient
        }

        console.log("TMX Client store service loaded.");

        // Return the service
        return clientService;

        // CRUD Operations
        function getClientByEmail(email) {

            console.log("[LOG]: in getClientByEmail(email)");

            if (email != null && email != "") {
                Client.get({ email: email }, function (result) {
                    console.log("Result is back!!");
                    console.log(result);
                });
            }


        }

        function saveClient(client) {

        }

        function updateClientByEmail(email, client) {

        }

        function deleteClientByEmail(email) {

        }

        function updateEmailForClient(email, newEmail) {

        }

    }

})();